import { render, staticRenderFns } from "./privacySetting.vue?vue&type=template&id=36c3f81c&"
import script from "./privacySetting.vue?vue&type=script&lang=js&"
export * from "./privacySetting.vue?vue&type=script&lang=js&"
import style0 from "./privacySetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports